<template>
  <div class="ossData-container">
    <div class="ossData-card">
      <div class="ossData-barChart-header">
        <div class="font-format-big">ONYX云空间</div>
        <!-- <div>查看详情</div> -->
      </div>
      <div class="ossData-main">
        <div class="ossData-main-left">
          <div class="ossData-useInfo">
            <div class="ossData-useInfo-item">
              <div class="ossData-useInfo-item-title">总用量：</div>
              <div class="ossData-useInfo-item-value">
                {{ chartData.total ? filterSize(chartData.total.count) : 0 }}
              </div>
            </div>
          </div>
          <div class="ossData-chart-row">
            <div
              class="ossData-chart-col"
              v-for="item in chartData.data"
              :key="item.key"
            >
              <div
                class="ossData-chart-col-point"
                :style="`background:${item.color}`"
              ></div>
              <div class="ossData-chart-col-value">
                {{ filterName(item.name) }}
                {{ ((item.count / chartData.total.count) * 100).toFixed(2) }}%
              </div>
            </div>
          </div>
        </div>
        <div class="ossData-chart" ref="ossDataChart">
          <div ref="ossChart" style="width: 100%;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  props: {
    ossStorage: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      myChart: null,
      chartData: [],
      option: {
        // backgroundColor: '#0a1a2a',
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff',
          borderWidth: 1,
          borderColor: '#dcdcdc',
          formatter: (params) => {
            return `
               <span style="color:#000">
                ${params.seriesName}
               </span>
                <br/>
                  ${params.marker}
                <span style="color:#000">
                  ${params.data['name']}
                  ：
                  ${this.filterSize(params.data['value'])}
                </span>
              `
          }
        },
        series: [
          {
            name: '容量信息',
            type: 'pie',
            radius: '60%',
            // center: ['45%', '48%'],
            color: [],
            minAngle: 5, //最小角度
            labelLine: {
              smooth: false,
              // length: 20,
              // length2: 70,
              lineStyle: {
                width: 1
                // color: '#dcdcdc',
              }
            },
            label: {
              formatter: (params) => {
                return `{a|${params.data['name']}}\n{b|${this.filterSize(
                  params.data['value']
                )}}`
              },
              rich: {
                a: {
                  fontWeight: 500,
                  color: '#292929'
                },
                b: {
                  fontWeight: 400,
                  color: '#888888'
                }
              }
              // padding: [0, -65]
            },
            emphasis: {
              scaleSize: 10,
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.28)'
              }
            },
            data: []
          }
        ]
      }
    }
  },
  methods: {
    initChart() {
      let color = {
        doc: { value: 'rgba(255,107,107, 1)' },
        other: { value: 'rgba(100,247,114,1)' },
        appData: { value: 'rgba(223,154,255,1)' },
        push: { value: 'rgba(255,220,38, 1)' },
        reader: { value: 'rgba(72,170,255, 1)' },
        share: { value: 'rgba(255,176,112, 1)' }
      }
      // let color1 = {
      //   doc: { value: 'rgba(255,107,107, 0.4)' },
      //   total: { value: 'rgba(48,241,230,0.4)' },
      //   other: { value: 'rgba(100,247,114,0.4)' },
      //   appData: { value: 'rgba(223,154,255,0.4)' },
      //   push: { value: 'rgba(255,220,38, 0.4)' },
      //   reader: { value: 'rgba(72,170,255, 0.4)' },
      //   share: { value: 'rgba(255,176,112, 0.4)' }
      // }

      this.chartData = JSON.parse(JSON.stringify(this.ossStorage))
      if (!this.myChart) {
        this.myChart = echarts.init(this.$refs.ossChart)
      }

      let arr = []
      let arr1 = []
      let colorArr = []
      let colorArr1 = []
      for (let item of this.chartData.data) {
        arr = [
          ...arr,
          {
            name: this.filterName(item.name),
            value: item.count <= 0 ? 0 : item.count
          }
        ]
        // arr1 = [...arr1, { name: '', value: i.count <= 0 ? 0 : i.count }]

        if (color[item.name]) {
          item.color = color[item.name].value
          colorArr = [...colorArr, color[item.name].value]
          // colorArr1 = [...colorArr1, color1[i.name].value]
        }
      }
      // this.option.series[0].color = colorArr1
      // this.option.series[0].data = arr1
      this.option.series[0].color = colorArr
      this.option.series[0].data = arr
      this.myChart.setOption(this.option)
      console.log(this.chartData, 'pzzz')
    },

    filterName(name) {
      let str
      switch (name) {
        case 'doc':
          str = '云端笔记'
          break
        case 'other':
          str = '其他数据'
          break
        case 'push':
          str = '云端推送'
          break
        case 'appData':
          str = '云端备份'
          break
        case 'reader':
          str = '阅读数据'
          break
        case 'share':
          str = '分享笔记'
          break

        default:
          break
      }
      return str
    },

    filterSize(value) {
      if (value === null || value === '' || !value) {
        return '0 B'
      }
      let unitArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      let index = 0
      let srcsize = parseFloat(value)
      index = Math.floor(Math.log(srcsize) / Math.log(1024))
      var size = srcsize / Math.pow(1024, index)
      //  保留的小数位数
      size = size.toFixed(2)
      return size + unitArr[index]
    },

    chartResize() {
      this.myChart ? this.myChart.resize({ width: 'auto' }) : null
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize)
  },
  mounted() {
    if (this.$refs.ossChart) {
      this.$refs.ossChart.style.height =
        this.$refs.ossDataChart.clientHeight + 'px'
    }
    this.initChart()
    window.addEventListener('resize', this.chartResize)
  }
}
</script>

<style lang="scss">
.ossData-container {
  flex: 1;
  display: flex;
  overflow: hidden;
  /* padding: 10px 20px; */
  > .ossData-card {
    flex: 1;
    /* height: 420px; */
    display: flex;
    flex-direction: column;
    padding: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
    background: #fff;
    box-sizing: border-box;
    border-radius: 4px;
    .ossData-barChart-header {
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .ossData-main {
      display: flex;
      flex: 1;
      /* align-items: center; */
      .ossData-main-left {
        width: 310px;
        .ossData-useInfo {
          padding: 20px;
          box-sizing: border-box;
          background: #f9f9f9;
          border-radius: 10px;
          margin-right: 30px;
          .ossData-useInfo-item {
            /* display: flex;
          justify-content: space-between; */
            align-items: center;
            margin-bottom: 6px;
            .ossData-useInfo-item-name {
              font-size: 14px;
              color: #888888;
            }
            .ossData-useInfo-item-value {
              font-size: 24px;
              color: #c90d0d;
            }
          }
        }
        .ossData-chart-row {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 10px;
          padding: 20px 0;
          .ossData-chart-col {
            display: flex;
            align-items: center;
            /* justify-content: center; */
            .ossData-chart-col-point {
              width: 10px;
              height: 10px;
              border-radius: 8px;
              margin-right: 10px;
            }
          }
        }
      }
      .ossData-chart {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }
}
</style>
